import AbstractFilter from '../AbstractFilter';
import { FILTER_EVENT } from '../FilterEvent';

export default class EnhancedExpandedSelectFilter extends AbstractFilter {
  constructor(...args) {
    super(...args);
    this._values = [];
    this._autoSubmit = this._dom.container.hasAttribute('data-auto-submit') ?? false;
    this._widget = null;
  }

  _init() {
    super._init();
    this._generateChoices();
    this._choiceLabel = null;
    this._choices = this._choicesContainer.querySelectorAll('label');
    this._choices.forEach((choice) => {
      choice.addEventListener('click', (event) => {
        event.stopPropagation();
        event.preventDefault();
        this._choiceSelected(choice);
      });
    });
  }

  _generateChoices() {
    this._dom.container.style.display = 'none';
    this._choicesContainer = document.createElement('div');
    this._choicesContainer.classList.add('expanded-choice-list');

    let html = '';
    this._dom.container.querySelectorAll('option').forEach((option) => {
      if (option.value) {
        html += `<label><input type="radio" value="${option.value}" />${option.innerText}</label>`;
      }
    });
    this._choicesContainer.innerHTML = html;
    this._dom.container.parentNode.append(this._choicesContainer);
  }

  _choiceSelected(choice) {
    this._values = [choice.querySelector('input').value];
    this._choiceLabel = choice.innerText.trim();
    this.emit(FILTER_EVENT.CHANGED, { interactive: true });
  }

  getChoiceLabel() {
    return this._choiceLabel;
  }

  reset() {
    console.log('todo : implement reset ?');
  }

  hide() {
    console.log('todo : implement hide ?');
  }

  show() {
    console.log('todo : implement show ?');
  }

  isMultiple() {
    return false;
  }
}
